import { Navigate, useParams } from 'react-router-dom';

import { Loading } from '@/components';
import { useGetFolderStatusAndItsTypologyAsync } from '@/features/easy/shared/apis';

export const NavigationSwitcher = () => {
  const { folderId } = useParams();
  const { data: folderStatusAndItsTypologyData, isLoading: isfolderStatusAndItsTypologyDataLoading } =
    useGetFolderStatusAndItsTypologyAsync({
      folderId,
    });

  if (isfolderStatusAndItsTypologyDataLoading) {
    return <Loading />;
  }

  return folderStatusAndItsTypologyData.isFolder ? (
    <Navigate to={`/folders/${folderId}/customs-documents`} />
  ) : (
    <Navigate to={`/pre-folders/${folderId}/qualification`} />
  );
};
